module.exports = __webpack_public_path__ + "img/5.46969836.png";